import React, { MouseEvent, useState } from 'react'
import OutsideClickHandler from 'react-outside-click-handler'
import cx from 'classnames'
import { useWindowSize } from 'utils/hooks'
import { CalendarNavProps } from 'types/calendar'
import styles from '../ShowsCalendar.module.scss'
import dayjs from 'utils/dayjs'

const CaretDown = (
  <svg xmlns='http://www.w3.org/2000/svg' width='14' height='15' viewBox='0 0 14 15' fill='none'>
    <g id='keyboard_arrow_down'>
      <mask
        id='mask0_11888_24546'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='14'
        height='15'
      >
        <rect id='Bounding box' y='0.5' width='14' height='14' fill='white' />
      </mask>
      <g mask='url(#mask0_11888_24546)'>
        <path
          id='keyboard_arrow_down_2'
          d='M7 11.1856L1 5.1856L1.6856 4.5L7 9.81468L12.3144 4.5L13 5.1856L7 11.1856Z'
          fill='white'
        />
      </g>
    </g>
  </svg>
)

const CaretUp = (
  <svg xmlns='http://www.w3.org/2000/svg' width='14' height='15' viewBox='0 0 14 15' fill='none'>
    <g id='keyboard_arrow_up'>
      <mask
        id='mask1_11888_24547'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='14'
        height='15'
      >
        <rect id='Bounding box' y='0.5' width='14' height='14' fill='white' />
      </mask>
      <g mask='url(#mask1_11888_24547)'>
        <path
          id='keyboard_arrow_up_2'
          d='M7 4.5L1 10.5L1.6856 11.1856L7 5.87091L12.3144 11.1856L13 10.5L7 4.5Z'
          fill='white'
        />
      </g>
    </g>
  </svg>
)

interface MonthOption {
  label: string
  shortLabel: string
  value: string
}

const CalendarNav = ({
  calendarFilterItems,
  selectedMonth,
  handleMonthNavChange,
  loadCalendarData,
  activeMonthList
}: CalendarNavProps) => {
  const parseDate = (dt: string, format: string) => dayjs(dt, 'MMM-YYYY').format(format)
  const [isNavOpen, showIsNavOpen] = useState(false)
  const toggleOptions = () => showIsNavOpen(!isNavOpen)
  const { isBreakpoint: isBelowBreakpointMd } = useWindowSize('md', '<')
  const dropdownSelectedField = isBelowBreakpointMd ? 'shortLabel' : 'label'
  const monthOptions = activeMonthList.map(x => ({
    label: parseDate(x, 'MMMM YYYY'),
    shortLabel: parseDate(x, 'MMM YYYY'),
    value: parseDate(x, 'MMMM-YYYY')
  }))

  const setActiveMonth = (event: MouseEvent<HTMLLIElement>) => {
    const text = (event.target as HTMLLIElement).innerText
    const [selectedMonth] = monthOptions.filter(month => month[dropdownSelectedField] === text)
    const parsedDate = dayjs(selectedMonth.label, 'MMMM YYYY')
    const currentMonth = dayjs(parsedDate).startOf('month')
    showIsNavOpen(false)
    handleMonthNavChange(selectedMonth)
    loadCalendarData(currentMonth)
  }

  const closeAllOptions = () => showIsNavOpen(false)

  return (
    <div className={styles['calendar-nav']}>
      <OutsideClickHandler
        onOutsideClick={() => {
          closeAllOptions()
        }}
      >
        <div className={styles['calendar-form-input']}>
          <div onClick={() => toggleOptions()} className={cx([styles['options-toggler']])}>
            {selectedMonth.label}
            <div className={styles['caret']}>{isNavOpen ? CaretUp : CaretDown}</div>
          </div>
          {isNavOpen && calendarFilterItems.length && (
            <div className={styles['options-container']}>
              <ul>
                {monthOptions.map((month: MonthOption, i: number) => (
                  <li
                    className={cx([
                      styles['option'],
                      styles[selectedMonth[dropdownSelectedField] == month[dropdownSelectedField] ? 'active' : '']
                    ])}
                    data-id={month.value}
                    key={i}
                    onClick={e => setActiveMonth(e)}
                  >
                    {month[dropdownSelectedField]}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </OutsideClickHandler>
    </div>
  )
}

export default CalendarNav
